const _ = require('lodash');
const toggles = require('../toggles');
const EnvironmentsToggles = require('../environments');
const mix = require('./mix');

// For convenience
exports.EnvironmentsToggles = EnvironmentsToggles;


/**
 * Mixin methods which allow to add EnvironmentToggles into ConfigurePane
 *
 * @param superclass
 * @returns {{}}
 * @constructor
 */
function EnvironmentsPaneMixin(superclass) {
	return class extends superclass {
		initEnvironmentsToggles(options) {
			options = Object.assign({method: 'eventsEnvironmentsList'}, options);
			this.addComponent('environments', new EnvironmentsToggles(options));
		}

		get environmentTogglesController() {
			return this.getComponent('environments');
		}
	}
}

mix.MIXINS.set('ENVIRONMENTS', EnvironmentsPaneMixin);
exports.mixin = EnvironmentsPaneMixin;